export default {
  // Tab labels
  transactionAnalysis: "Transaction Analysis",
  keyTransactions: "Key Transactions",
  counterparty: "Counterparty (USDT)",
  transactionDetails: "Main Coin Transfer",
  tokenTransfer: "Token Transfer",
  otherInfo: "Other Info",
  assets: "Assets",

  // Statistics
  total: "Total",
  totalData: "records",

  // Search and filter
  searchCounterpartyAddress: "Search counterparty address",
  minAmount: "Min Quantity",
  maxAmount: "Max Quantity",
  minCount: "Min Count",
  maxCount: "Max Count",
  pleaseSelect: "Please select",
  pleaseSelectCurrency: "Please select currency",
  pleaseSelectCurrencyFirst: "Please select currency first",

  // Date picker
  startDate: "Start Date",
  endDate: "End Date",

  // Buttons
  reset: "Reset",
  query: "Query",

  // Validation messages
  maxAmountError: "Max amount must be ≥ min amount",
  maxCountError: "Max count must be ≥ min count",

  // Options
  senderReceiver: "Sender/Receiver",
  sender: "Sender",
  receiver: "Receiver",

  // Checkbox
  hideZeroTransactions: "Hide transactions with zero amount",

  // Message prompts
  alreadyCurrentPage: "Already on current address details page!",

  // File name
  dataDetailsFileName: "Data Details",
};
